import { useEffect, useState } from "react";

import { isSupportedBrowser } from "../../../matteroomTab/Utils";

export const useUnsupportedBrowser = () => {
  const [unsupportedBrowser, setUnsupportedBrowser] = useState(false);

  useEffect(() => {
    if (!isSupportedBrowser()) {
      setUnsupportedBrowser(true);
    }
  }, []);

  return unsupportedBrowser;
};
